import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Laptop, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const PricesMobile = () => {
  const brands = [
    {
      name: 'Apple',
      path: '/priser/mobil/apple',
      icon: '🍎',
      description: 'iPhone reparasjon - alle modeller'
    },
    {
      name: 'Samsung',
      path: '/priser/mobil/samsung',
      icon: '📱',
      description: 'Samsung Galaxy reparasjon'
    },
    {
      name: 'Huawei',
      path: '/priser/mobil/huawei',
      icon: '📲',
      description: 'Huawei reparasjon - P & Mate serier'
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-16">
      {/* Hero */}
      <section className="bg-gradient-to-br from-sky-50 to-cyan-50 py-16 mb-16">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-sky-500 to-cyan-500 rounded-2xl mb-6">
            <Smartphone size={32} className="text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Mobilreparasjon <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-cyan-600">Priser</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Velg ditt mobilmerke for å se priser
          </p>
        </div>
      </section>

      {/* Brand Selection */}
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {brands.map((brand, index) => (
            <Link key={index} to={brand.path}>
              <Card className="hover:shadow-2xl transition-all hover:-translate-y-2 border-2 hover:border-sky-300 cursor-pointer h-full">
                <CardContent className="p-8 text-center">
                  <div className="text-6xl mb-4">{brand.icon}</div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{brand.name}</h3>
                  <p className="text-gray-600 mb-4">{brand.description}</p>
                  <div className="inline-flex items-center gap-2 text-sky-600 font-semibold">
                    Se priser
                    <ChevronRight size={20} />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

        {/* Info Cards */}
        <div className="grid md:grid-cols-3 gap-6 mt-16 max-w-5xl mx-auto">
          <Card className="bg-gradient-to-br from-sky-50 to-white border-2 border-sky-100">
            <CardContent className="p-6 text-center">
              <div className="text-3xl font-bold text-sky-600 mb-2">2 år</div>
              <div className="font-semibold text-gray-900 mb-1">Garanti</div>
              <p className="text-sm text-gray-600">På alle deler og reparasjoner</p>
            </CardContent>
          </Card>
          <Card className="bg-gradient-to-br from-cyan-50 to-white border-2 border-cyan-100">
            <CardContent className="p-6 text-center">
              <div className="text-3xl font-bold text-cyan-600 mb-2">30 min</div>
              <div className="font-semibold text-gray-900 mb-1">Rask service</div>
              <p className="text-sm text-gray-600">De fleste reparasjoner</p>
            </CardContent>
          </Card>
          <Card className="bg-gradient-to-br from-sky-50 to-white border-2 border-sky-100">
            <CardContent className="p-6 text-center">
              <div className="text-3xl font-bold text-sky-600 mb-2">Gratis</div>
              <div className="font-semibold text-gray-900 mb-1">Diagnose</div>
              <p className="text-sm text-gray-600">Vi sjekker enheten din gratis</p>
            </CardContent>
          </Card>
        </div>

        {/* Note */}
        <Card className="mt-8 border-l-4 border-l-sky-600 max-w-5xl mx-auto">
          <CardContent className="p-6">
            <p className="text-gray-600">
              <strong className="text-gray-900">Viktig:</strong> Alle priser er inkludert moms. 
              Prisene kan variere avhengig av modell og skadens omfang. 
              Kontakt oss for eksakt pristilbud. Vi tilbyr også studentrabatt og bedriftsavtaler.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PricesMobile;
